import { useQuery } from '@tanstack/react-query';

import { listKubernetesScopedKubeconfigs } from '@api/sdk.gen';

import { withError } from '@/react-tools/react-query';
import { EnvironmentId } from '@/react/portainer/environments/types';

import { ScopedKubeconfig } from '../types';

import { queryKeys } from './query-keys';

/**
 * Scoped kubeconfigs issued for one environment. The API filters by ownership,
 * so a non-admin is served only their own rows.
 */
export function useScopedKubeconfigs<T = ScopedKubeconfig[]>(
  environmentId: EnvironmentId,
  {
    select,
    enabled,
  }: { select?: (data: ScopedKubeconfig[]) => T; enabled?: boolean } = {}
) {
  return useQuery({
    queryKey: queryKeys.environment(environmentId),
    queryFn: () => getScopedKubeconfigs(environmentId),
    ...withError('Unable to retrieve scoped kubeconfigs'),
    select,
    enabled,
  });
}

async function getScopedKubeconfigs(
  environmentId: EnvironmentId
): Promise<ScopedKubeconfig[]> {
  const { data } = await listKubernetesScopedKubeconfigs({
    path: { id: environmentId },
  });

  return data ?? [];
}
